import { render, staticRenderFns } from "./DataCount.vue?vue&type=template&id=52626f1a&scoped=true"
import script from "./DataCount.vue?vue&type=script&lang=js"
export * from "./DataCount.vue?vue&type=script&lang=js"
import style0 from "./DataCount.vue?vue&type=style&index=0&id=52626f1a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52626f1a",
  null
  
)

export default component.exports